<h1 mat-dialog-title>Confirm</h1>
<div mat-dialog-content>{{ data.message }}</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel();">No</button>
    <button mat-raised-button color="primary" (click)="onConfirm();">Yes</button>
</div>